import axios from 'axios'
import { clarify } from '@/utils/clear'
import { DEV_MODE } from '@/config/dev-mode'
import { validateBaseServiceResponse } from '@/utils/baseServiceValidator'

const endpoint = import.meta.env.VITE_APP_GW_URL
const systemId = import.meta.env.VITE_APP_SYSTEM_ID

/**
 * [분석 서비스 API]
 *
 * @description
 * 분석 타입(`analysisTypeId`)에 따라 적절한 데이터를 조회하는 API입니다.
 * 필수 파라미터로 `analysisTypeId`가 요구됩니다.
 *
 * @param {Object} params - 요청에 사용할 쿼리 파라미터
 * @param {number} params.analysisTypeId - 분석 유형 ID (필수)
 *
 * 분석 유형:
 * - 3: 성향분석
 * - 4: 사주분석
 * - 7: 생활요약
 *
 * @returns {Promise<Object>} API 응답 데이터
 */
export const fetchBaseServiceAPI = async (params, options = {}) => {
  // options 로 axios 설정(timeout 등)을 덮어쓸 수 있다. 작명(작명추천 ~130초)은 timeout: 200_000 사용.
  const response = await axios.get(`${endpoint}/fast/base-service`, { params, ...options })

  if (DEV_MODE) {
    validateBaseServiceResponse(params.analysisTypeId, response?.data?.data)
  }

  return response?.data
}

/**
 * [낭만궁합 서비스 API]
 *
 * @param {Object} params
 * @param {number} params.guestUserId - 본인 사주 ID
 * @param {string} params.category - 카테고리 (LOVER/FRIEND/BUSINESS/FAMILY)
 * @param {number[]} params.memberIds - 대상자 사주 ID 배열
 * @param {number} [params.suggestionFlag=3]
 * @param {number} [params.analysisTypeId=38]
 */
export const fetchHarmonyServiceAPI = async (params) => {
  const { memberIds, ...rest } = params
  const query = new URLSearchParams(
    clarify({
      suggestionFlag: 3,
      analysisTypeId: 38,
      ...rest,
    }),
  )
  if (memberIds?.length) {
    memberIds.forEach((id) => query.append('memberIds', id))
  }
  const response = await axios.get(`${endpoint}/fast/base-service?${query.toString()}`)
  return response?.data
}

/** 상세분석 내 좋아요 */
export const patchAnalysisLike = async (type, id, contentKey = null) => {
  const params = new URLSearchParams(
    clarify({
      likeType: type,
      systemId,
      contentKey,
    }),
  )
  const response = await axios.patch(`${endpoint}/like/${id}?${params.toString()}`)
  return response.data
}

/* 직업추천 좋아요 조회 */
export const gatchAnalysisLike = async (type, id, contentKey = null) => {
  const params = new URLSearchParams(
    clarify({
      systemId,
      contentKey,
    }),
  )
  const response = await axios.get(`${endpoint}/like/checkLike/${type}/${id}?${params.toString()}`)
  return response.data
}
